<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 17V9" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 17V5" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 17V14" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'DashboardIcon',
  props: ['color']
}
</script>
